import React from "react";

const WhatsAppCoexistence = () => {
  const conectarWhatsApp = () => {
    if (!window.FB) {
      console.log("Facebook SDK todavía no está cargado");
      return;
    }

    window.FB.login(
      (response) => {
        console.log("RESPUESTA META:", response);

        if (response.authResponse) {
          console.log(
            "CODE:",
            response.authResponse.code,
          );
        }
      },
      {
        config_id: "1741416090513525",
        response_type: "code",
        override_default_response_type: true,

        extras: {
          setup: {},
          featureType: "whatsapp_business_app_onboarding",
          sessionInfoVersion: "3",
        },
      },
    );
  };

  return (
    <div>
      <button onClick={conectarWhatsApp}>
        Conectar WhatsApp Business
      </button>
    </div>
  );
};

export default WhatsAppCoexistence;